/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';

import PropTypes from 'util/PropTypes';

import './fieldsList.scss';

class FakeFieldsList extends Component {

	render() {

		const fakeFields = [];

		for(let i = 0; i < this.props.numberOfFields; i++) {
			fakeFields.push(<div className='fakeField' />);
		}


		return (
			<div className="fieldsListContainer">
				<div className="fieldsList">
					{fakeFields}
				</div>
			</div>
		);
	}

}

FakeFieldsList.propTypes = {
	numberOfFields: PropTypes.number.isRequired
};

export default FakeFieldsList;



// WEBPACK FOOTER //
// ./src/js/components/fieldsList/FakeFieldsList.js